import { gql } from '@apollo/client';
import { AccountAddressInfoShared, ErrorMessageInfo } from '../fragments';

export default gql`
  mutation updateAccountAddress($input: AccountAddressUpdateInput!) {
    updateAccountAddress(input: $input) {
      clientMutationId
      errorMessages {
        ...ErrorMessageInfo
      }
      accountAddress {
        ...AccountAddressInfoShared
      }
    }
  }
  ${AccountAddressInfoShared}
  ${ErrorMessageInfo}
`;
